import React, { useState, useEffect } from 'react';

// Constants
import { QuickStartGuideItems } from '../../QuickStartGuideItems.constants';

// Components
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import QsgTitle from '../QsgTitle';
import QsgStepTempate from '../QsgStepTemplate';

type Props = {
  setActiveStepId: Function;
  activeStepId;
};
const QsgStep = ({ setActiveStepId, activeStepId }: Props) => {
  const [step, setStep] = useState(null);
  const handleBackClick = () => {
    setActiveStepId('start');
  };

  // By setting the step in a local state variable,
  // it allows us to maintain the step on the canvas while
  // transitioning back to the list
  useEffect(() => {
    if (activeStepId !== 'start') setStep(QuickStartGuideItems.find(item => item.id === activeStepId));
  }, [activeStepId]);

  if (!step) return null;

  const Component = step?.component;

  return (
    <QsgStepTempate
      title={
        <QsgTitle
          title={step.title}
          inverseGradient
          prefixButton={
            <WpButton variant="tertiary" color="white" size="sm" onClick={handleBackClick}>
              <WpIcon name="chevron-left" />
            </WpButton>
          }
        />
      }
      description={step.description}
    >
      <Component navigateToList={handleBackClick} />
    </QsgStepTempate>
  );
};

export default QsgStep;
